import PwcCustomersContainer from './list/container';
import { PwcCustomerViewContainer } from './view/container';

export const PwcCustomersListRoute = PwcCustomersContainer;
export const PwcCustomerViewRoute = PwcCustomerViewContainer;
